/**
=========================================================
* Material Dashboard 2  React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/* eslint-disable no-dupe-keys */
// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

const { gradients, dark } = colors;

function configs(labels, datasets, cutout = 60) {
  const vibrantColors = [
    "#3A6EA5", // Steel Blue
    "#61C0BF", // Soft Cyan
    "#F3A712", // Warm Amber
    "#DF7861", // Soft Coral
    "#6A67CE", // Lavender Purple
    "#99C24D", // Lime Green
    "#7D91D4", // Periwinkle Blue
  ];

  const backgroundColors = datasets.backgroundColors
    ? datasets.backgroundColors.map((color, index) =>
        gradients[color] ? gradients[color].state : vibrantColors[index % vibrantColors.length]
      )
    : vibrantColors.slice(0, labels.length);

  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets.label,
          weight: 9,
          cutout,
          tension: 0.9,
          pointRadius: 2,
          borderWidth: 2,
          backgroundColor: backgroundColors,
          fill: false,
          data: datasets.data,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
    },
  };
}

export default configs;
